module.exports = __webpack_public_path__ + "img/roller.ac98119d.svg";